<!-- use the same img in both DM & LM by inverting it, match background -->
<div *ngIf="!isWorkforceLogin" class="tw-bg-gray-100 tw-absolute tw-inset-0">
  <img
    class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-object-cover tw-transition-all tw-grayscale tw-mix-blend-multiply"
    [ngClass]="{ 'tw-filter tw-invert': !(darkModeService.darkMode$ | async) }"
    src="../../../assets/img/globe-dark.png"
    loading="lazy"
    alt="global data flow and connectivity, black and white planet Earth" />
</div>

<div *ngIf="isWorkforceLogin" class="wf-decoration-visual tw-bg-gray-900 3xl:tw-w-[700px]">
  <h1
    class="tw-text-white tw-text-center tw-font-medium tw-tracking-widest tw-mx-auto tw-mb-12 tw-flex tw-flex-col tw-items-center tw-text-[1.7rem] tw-leading-[1.9rem] 3xl:tw-text-[2rem] 3xl:tw-leading-[2.5rem] tw-mt-12 3xl:tw-mt-0 3xl:tw-font-normal">
    <span class="tw-text-gray-300">Competitive insights</span>
    <span class="tw-text-gray-300">
      on any company
      <span class="tw-text-indigo-600">in seconds.</span>
    </span>
  </h1>

  <div
    class="tw-flex tw-flex-col tw-gap-y-12 3xl:tw-flex-row tw-justify-center tw-items-center tw-gap-4 3xl:tw-relative 3xl:tw-h-[700px] tw-mb-12 3xl:tw-mb-0">
    <!-- left side -->
    <div
      class="3xl:tw-w-[400px] tw-w-[300px] tw-p-4 tw-bg-gray-700 tw-rounded-lg 3xl:tw-absolute 3xl:tw-top-0 3xl:tw-left-0 tw-shadow-2xl tw-shadow-teal-400/50">
      <h2
        class="tw-text-gray-300 tw-text-center tw-font-normal tw-text-xl tw-mt-2 tw-max-w-[280px] tw-mx-auto tw-tracking-widest">
        Compare any company head to head
      </h2>
      <div>
        <img
          class="3xl:tw-w-[400px] tw-w-[300px]"
          src="../../../assets/img/Frame 44908.png"
          loading="lazy"
          alt="several charts comparing people data in battle mode for seven companies" />
      </div>
    </div>

    <!-- right side -->
    <div
      class="3xl:tw-w-[400px] tw-w-[300px] tw-p-4 tw-bg-gray-700 tw-rounded-lg 3xl:tw-absolute 3xl:tw-top-[220px] 3xl:tw-right-0 tw-shadow-2xl tw-shadow-teal-400/50 tw-border tw-border-solid tw-border-gray-600">
      <h2
        class="tw-text-gray-300 tw-text-center tw-font-normal tw-text-xl tw-mt-2 tw-max-w-[280px] tw-mx-auto tw-tracking-widest">
        See the people behind every chart
      </h2>
      <div>
        <img
          class="3xl:tw-w-[400px] tw-w-[300px]"
          src="../../../assets/img/Frame 44909.png"
          loading="lazy"
          alt="person profile with a chart of their data" />
      </div>
    </div>
  </div>
</div>
